export default __webpack_public_path__ + "static/media/deco-img(5).e3a6c322.png";